import http from 'plugins/axios'

export default {
  exportExcel({ userId, startTime, endTime }) {
    return http.get({
      url: `/la/admin/workorder/findByUse/wallet/excel?userId=${userId}&startTime=${startTime}&endTime=${endTime}`,
      responseType: 'blob',
    })
  },
  getExcelData(params) {
    return http.get({
      url: `/la/admin/workorder/search_withdraw?${params}`,
      responseType: 'blob',
    })
  },
  getChains() {
    return http.get({
      url: '/la/admin/coin/chain/list',
    })
  },
  getChooseData() {
    return http.get({
      url: '/la/admin/coin/allDisplay/spit',
    })
  },
  getAuditList(data) {
    return http.get({
      url: '/la/admin/workorder/search_withdraw',
      data,
    })
  },
  approveAudit({ id, googleCode }) {
    return http.post({
      url: '/la/admin/workorder/approve_withdraw',
      data: { id, googleCode },
      dataType: 'form',
    })
  },
  //批量审核
  batchApproveAudit({ id, googleCode }) {
    return http.post({
      url: `/la/admin/workorder/approve_withdraw/list?id=${id}&googleCode=${googleCode}`,
    })
  },
  retryWithdrawal(data) {
    return http.post({
      url: '/la/admin/workorder/retry_withdraw',
      data,
      dataType: 'form',
    })
  },
  setToErrList(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form',
    })
  },
  cancelAudit(id) {
    return http.post({
      url: '',
      data: { id },
      dataType: 'form',
    })
  },
  getAllCoins() {
    return http.get({
      url: '/la/admin/coin/allDisplay',
    })
  },
  getUserRecords(data) {
    return http.get({
      url: '/la/admin/workorder/findByUse/Forward',
      data: {
        useId: data.userId,
        page: data.page,
        size: data.size,
      },
    })
  },
  getBillTypeList() {
    return http.get({
      url: '/la/admin/bill/types',
    })
  },
  updateFreeze(id) {
    return http.post({
      url: '/la/admin/workorder/freeze_withdraw',
      data: {
        id,
      },
      dataType: 'form',
    })
  },
  cancel(id) {
    return http.post({
      url: '/la/admin/workorder/cancel_withdraw',
      data: {
        id,
      },
      dataType: 'form',
    })
  },
  sendTheWithdrawalTrans(data) {
    return http.post({
      url: '/la/admin/workorder/handed_network_withdraw',
      data: {
        networkId: data.transId,
        id: data.id,
        googleCode: data.googleCode,
      },
      dataType: 'form',
    })
  },
  getUserWallet(id) {
    return http.get({
      url: '/la/admin/workorder/findByUse/wallet',
      data: {
        userId: id,
      },
    })
  },
  remark(data) {
    return http.get({
      url: '/la/admin/workorder/add/remark',
      data,
    })
  },
  manualConfirm(id) {
    return http.post({
      url: '/la/admin/workorder/manual_confirm',
      data: {
        id,
      },
      dataType: 'form',
    })
  },
  returnToNotApproved(id) {
    return http.post({
      url: '/la/admin/workorder/return_to_not_approved',
      data: {
        id,
      },
      dataType: 'form',
    })
  },
  sentConfirmed(data) {
    return http.post({
      url: '/la/admin/workorder/withdraw/sent',
      data,
      dataType: 'form',
    })
  },
}
